<template>
    <b-col cols="12" class="mt-4 text-center terms-disclosure">
        <span class="agree">
            <span class="agree" v-html="getLegalWarning1Text()"></span>
            <a class="agree-links" href="https://jausa.ja.org/about/website-terms-and-conditions" target="_blank">
              {{ $t("legal_warning_2") }}
            </a>
              {{ $t("legal_warning_3") }}
            <a class="agree-links" href="https://jausa.ja.org/about/privacy-policy" target="_blank">{{ $t("legal_warning_4") }}</a>
        </span>
        <br>
    </b-col>
</template>

<script>
    import { UtilsI18n } from "../../../core/Utils";

    export default {
        name: "LegalWarning",
        props: {
            button: {
                type: String,
                required: true
            }
        },
      methods: {
        getLegalWarning1Text: function() {
          return UtilsI18n.interpolateString(this.$t("legal_warning_1"), {button_text: this.button})
        },
      }
    }
</script>

<style lang="stylus" scoped>
    @import "~@/core/Styles/variables.styl"

    .terms-disclosure
        line-height 1.2

    .agree
        font-family arial, sans-serif
        font-size 12px
        font-style italic

    .agree-links
        font-family arial, sans-serif
        font-size 12px
        font-style italic
        color color-purple

    .last-updated
        font-family arial, sans-serif
        font-size 12px
        font-weight bold
        font-style italic
        color black
</style>
